<template>
    <div>
        <el-form :model="form" label-width="150px">
            <el-form-item label="包名">
                <el-input v-model="form.packageName"></el-input>
            </el-form-item>
            <el-form-item label="对象名称">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="是否可继承">
                <el-radio v-model="form.extendable" label="true">是</el-radio>
                <el-radio v-model="form.extendable" label="false">否</el-radio>
            </el-form-item>
            <el-form-item label="继承自">
                <el-select v-model="form.parent">
                    <el-option value="" label="java.lang.Object"></el-option>
                    <el-option v-for="(item, index) in extendableList" :key="index" :value="item.packageName+'.'+item.name" :label="item.packageName+'.'+item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关联数据库">
                <el-radio v-model="form.joinDb" label="true">是</el-radio>
                <el-radio v-model="form.joinDb" label="false">否</el-radio>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="form.note"></el-input>
            </el-form-item>
        </el-form>
    </div>
    
</template>

<script>

let that 

export default {
    
    data(){
        return {
            form: {
                packageName: '',
                name: '',
                parent: '',
                extendable: 'true',
                note: '',
                joinDb: 'true'
            },
            extendableList: [],
            project: {}
        }
    },
    
    methods: {
        handleConfirm() {
            if(that.form.joinDb) {
                that.form.tableName = that.form.name
            }
            let entityList = that.project.entityList || []
            entityList.push(that.form)
            that.project.entityList = entityList
            that.api.project.saveProjectConfig(that.project).then(() => {
                that.$alert('保存成功', '提示');
                that.$dialog.close('addObject')
            })
        }
    },
    mounted(){
        that = this
        this.api.system.findExtendableList().then(res => {
            that.extendableList = res.data
        })
        this.project = this.$store.state.currentProject

    }
}
</script>

